<template>
  <div class="bg-white flex flex-col items-start p-4">
    <div class="py-3 font-semibold text-lg">
      {{ $t('商家地址') }}
    </div>
    <div class="flex items-center">
      <span class="iconfont icon-shouhuodi text-main"></span>
      <span>{{ info.address }}</span>
    </div>
    <div class="py-3 font-semibold text-lg">
      {{ $t('商家信息') }}
    </div>
    <div>
      <span>{{ $t('店铺名称') }}:</span>
      <span>{{ info.name }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info:Object
  },
  setup() {
    return{}
  }
}
</script>
<style scoped lang="scss">
</style>